import {EMobilityToolsFeatureAppComponentLibrary} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

import {Accordion} from './accordion';
import {ActionTeaser} from './action-teaser';
import {Button, ButtonInverted} from './button';
import {ConfigureButton} from './configure-button';
import {DisclaimerReference} from './disclaimer-reference';
import {Disclaimer} from './disclaimer';
import {Divider} from './divider';
import {FaqList} from './faq';
import {Flag, FlagInverted} from './flag';
import {GroupedSelect, Select} from './select';
import {Icon, IconInverted} from './icon';
import {Image} from './image';
import {InfoButton, InfoButtonInverted} from './info-button';
import {Input} from './input';
import {LayerContainer} from './layer-container';
import {Link} from './link';
import {MultiSlider, Slider} from './slider';
import {RadioButton} from './radio-button';
import {Table} from './table';
import {Tabs} from './tabs';
import {Text, TextInverted} from './text';
import {Toggle} from './toggle';

export const ComponentsLibrary: EMobilityToolsFeatureAppComponentLibrary = {
  Accordion,
  ActionTeaser,
  Button,
  ButtonInverted,
  ConfigureButton,
  Disclaimer,
  DisclaimerReference,
  Divider,
  FaqList,
  Flag,
  FlagInverted,
  GroupedSelect,
  Icon,
  IconInverted,
  Image,
  InfoButton,
  InfoButtonInverted,
  Input,
  LayerContainer,
  Link,
  MultiSlider,
  RadioButton,
  Select,
  Slider,
  Table,
  Tabs,
  Text,
  TextInverted,
  Toggle,
} as unknown as EMobilityToolsFeatureAppComponentLibrary;
